import React, { useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
// Contexto
import dataContext from "../context/User";
// Helper
import SetBitacora from "../helper/SetBitacora";
import loadMenu from "../js/main";
import Footer from './Footer';
import BandejaCorreo from './BandejaCorreo';

const Correo = () => {

  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
  let correoPrint = null;


  if (datos) {
    let cred = JSON.parse(datos);
    dataUser.token = cred.token;
    dataUser.nombre = cred.nombre;
    dataUser.carnet = cred.carnet;
    // Correo institucional del usuario. No dependemos del `perfil` (su string
    // difiere entre ambientes: en prod puede venir "Administración y Finanzas"
    // en vez de "Administrativo", y la lista hardcodeada lo dejaba fuera).
    // Regla robusta: si el backend trae un correo @esen.edu.sv, ese es el
    // institucional (staff); si no, se arma con el carnet (alumnos).
    correoPrint =
      cred.correo && /@esen\.edu\.sv\s*$/i.test(cred.correo)
        ? cred.correo.trim()
        : cred.carnet + '@esen.edu.sv';
    SetBitacora.set(cred.carnet, 'Correo_electronico', cred.token);
  } else {
    history.push("/");
  }

  useEffect(() => {
    loadMenu();
  }, []);

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Correo institucional</h2>

        <BandejaCorreo correoEsperado={correoPrint} />
      </div>
    </div>
  );
};

export default Correo
